import { InputStateToken } from '@voltmoney/schema';
import { api, StoreKey } from '../../configs/api';
import { getAppHeader, getAuthHeaders } from '../../configs/config';
import _ from 'lodash';
import { ROUTE } from "../../routes";
import sharedPropsService from "../../SharedPropsService";
let isDisabled = false;
export const marketingLogin = async (action, _datastore, { setDatastore, network, asyncStorage, navigateToBase }) => {
    console.warn("*** marketingLogin action triggered *** : ", action);
    const lead = action.payload.lead;
    const leadId = lead?.leadId;
    const doLeadExist = action?.payload.doLeadExist ? action?.payload.doLeadExist : false;
    console.log("lead 123:", lead);
    if (action.payload.value.length !== 4)
        return;
    if (isDisabled)
        return;
    await setDatastore(ROUTE.MARKETING_LEAD_OTP, 'input', {
        state: InputStateToken.LOADING,
    });
    const loginResponse = await network.post(api.verifyOtp, {
        otp: action.payload.value,
        phoneNo: `${action.payload.phone}`,
    }, { headers: await getAuthHeaders() });
    if (_.get(loginResponse, 'status') === 200) {
        console.log("loginResponse 123: ", loginResponse);
        const accessToken = loginResponse?.data?.jwt;
        await sharedPropsService.setToken(accessToken);
        await asyncStorage.set(StoreKey.accessToken, accessToken);
        console.log("doLeadExist", doLeadExist);
        //set access token and set sharePropService
        if (!doLeadExist) {
            const leadResponse = await network.post(`${api.ConvertALeadToBorrower}${leadId}`, {}, {
                headers: await getAppHeader()
            });
        }
        //reset shared prop service
        await sharedPropsService.setMarketingLeadsData({
            fullName: '',
            phoneNumber: '',
            assetDetail: '',
            haveMutualFunds: ''
        });
        //reset stacks
        await setDatastore(action.routeId, 'MarketingLeadsYesContainer', { hide: true });
        await setDatastore(action.routeId, 'MarketingLeadsNoContainer', { hide: true });
        await setDatastore(action.routeId, 'MarketingLeadsCheckMFOption', { hide: false });
        await setDatastore(action.routeId, 'MarketingLeadsBottomParentBanner', { hide: false });
        await navigateToBase(ROUTE.MARKETING_LEAD_REDIRECT);
    }
    else {
        if (loginResponse?.response?.data?.voltErrorCode === "ACCOUNT_BLOCKED_FROM_OTP") {
            isDisabled = true;
            await setDatastore(ROUTE.MARKETING_LEAD_OTP, "input", {
                state: InputStateToken.DISABLED,
                caption: { error: "OTP limit exceeded. Please try again after 5 minutes." },
                otpLimitExceeded: true
            });
        }
        else {
            await setDatastore(ROUTE.MARKETING_LEAD_OTP, "input", {
                state: InputStateToken.ERROR,
                caption: { error: loginResponse.response.data.message }
            });
        }
    }
};
export const goBack = async (action, _datastore, { navigateToBase, instrumentTrack }) => {
    instrumentTrack("EDIT_PHONE_BUTTON_CLICKED");
    isDisabled = false;
    navigateToBase(ROUTE.MARKETING_LEAD);
};
